import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import slugify from 'react-slugify'
import { features, ToggleFeature } from 'features/ToggleFeature'

const getVendorURL = (item) => {
  const storesCustomURL = process.env.REACT_APP_CUSTOM_URL_STORE ? JSON.parse(process.env.REACT_APP_CUSTOM_URL_STORE) : {}
  if (Object.keys(storesCustomURL).find(key => parseInt(key) === parseInt(item.supplierId))) {
    return storesCustomURL[item.supplierId]
  } else if ((item.customUrlPage !== undefined) && (item.customUrlPage !== null)) {
    return item.customUrlPage
  }
  return `/vendor?vendor=${item.supplierId}`
}
const isExternalLink = (url) => {
  if (url) {
    const urlClean = url.toLowerCase()
    if (urlClean.indexOf('http://') > -1 || urlClean.indexOf('https://') > -1) {
      return true
    }
  }
  return false
}
const generateLink = (item) => {
  const urlVendor = getVendorURL(item)
  if (isExternalLink(urlVendor)) {
    return (
      <a target='_blank' href={urlVendor} className='txt-body-sm color-ui-1'>
        {item.name}
      </a>
    )
  }
  return (
    <Link to={urlVendor} className='txt-body-sm color-ui-1'>
      {item.name}
    </Link>
  )
}

const StoreGroup = ({ title, items, hasContent, hasCustomServices, hasCustomVendors }) => {
  return hasContent ? (
    <div className={`CategoryGroup col-12 pb-3 ${slugify(title, { delimiter: '-' })}`}>
      <h4 className='CategoryParent mb-1'>{title}</h4>
      <div className='CategoryChilds row'>
        {items.map((item, ix) => (

          (process.env.REACT_APP_CATALOG_ID === '40542' ||
            process.env.REACT_APP_CATALOG_ID === '40541' ||
            process.env.REACT_APP_CATALOG_ID === '40540' ||
            process.env.REACT_APP_CATALOG_ID === '40539' ||
            process.env.REACT_APP_CATALOG_ID === '40538' ||
            process.env.REACT_APP_CATALOG_ID === '40543' ||
            process.env.REACT_APP_CATALOG_ID === '40496')
            ? (item.supplierTypeId !== '4') && <div key={ix} className={`col-12 col-md-4 pt-half pl-3 pl-md-1  ${slugify(item.name, { delimiter: '-' })}`}>
              <p>
                { generateLink(item) }
              </p>
            </div>
            : <div key={ix} className={`col-12 col-md-4 pt-half pl-3 pl-md-1  ${slugify(item.name, { delimiter: '-' })}`}>
              <p data-supplierId={item.supplierTypeId}>
                { generateLink(item) }
              </p>
            </div>
        ))}
        {hasCustomVendors && <ToggleFeature feature={features.StoreGroup} /> }
        {hasCustomServices && <ToggleFeature feature={features.StoreServiceGroup} />}
      </div>
    </div>
  ) : (
    ''
  )
}
StoreGroup.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  hasContent: PropTypes.bool.isRequired,
  hasCustomServices: PropTypes.bool.isRequired,
  hasCustomVendors: PropTypes.bool.isRequired
}
export default StoreGroup



// WEBPACK FOOTER //
// ./src/features/Store/StoreGroup.js